import { HomeworkContent, HomeworkRepeatBy, HomeworkReleaseType } from './homework'

export enum HomeworkTemplateType {
  Official = 'official_tpl',
  Custom = 'custom_tpl',
}

export interface HomeworkTemplate {
  template_id: string
  image: string
  title: string
  subtitle: string
  grades: number[]
  class_ids: number[]
  start_date: string
  homework_contents: HomeworkContent[]
  message: string
  repeat_type: HomeworkRepeatBy
  release_type: HomeworkReleaseType
  is_check_wd5: boolean
  use_gender: boolean
  description?: string
  time_scope_category?: 'normal' | 'weekend'
  hw_tpl_id?: string
  tpl_type?: HomeworkTemplateType
  created_time: string
}

export interface HomeworkTemplateForm {
  hw_tpl: {
    id?: string
    title: string
    grades: number[]
    message: string
    description?: string
    repeat_type: HomeworkRepeatBy
    is_check_wd5: boolean
  }
  homework_contents: HomeworkContent[]
}

export enum HomeworkTemplateCategory {
  None = 'none', // 自定义布置
  Custom = 'custom', // 我的模版
  Official = 'official', // 官方模版
  Intelligent = 'intelligent', // 智能布置
}

export interface HomeworkPlanTemplate {
  goal: string
  stars: number
  title: string
  subtitle: string
  grades: number[]
  category: string
  message: string
  time_desc: string
  homework_contents: HomeworkContent[]
}
